import { Cashier } from '../models/interfaces/cashier';
import { toBranchOfficeModel } from './branch-office.mapper';
import { CashierForm } from '../models/interfaces/forms/cashier.form';
import { BranchOffice } from '../models/interfaces/branch-office';
import { CashierModel } from '../models/cashier.model';

export function toCashierModelCollection(collection: Cashier[]): CashierModel[] {
  return collection.map((data) => toCashierModel(data));
}

export function toCashierModel(data: Cashier): CashierModel {
  const model = new CashierModel();
  model.id = data.id;
  model.name = data.nombre;
  model.paymentOrders = data.trabajaOrdenesPago;
  model.branchOffice = toBranchOfficeModel(data.sucursal);
  model.externalQrId = data.qrExternoId;
  return model;
}

export function toCashierRequestDTO(cashier: CashierForm): Cashier {
  let response = {} as Cashier;

  if (cashier.id) {
    response.id = cashier.id;
  }
  response.nombre = cashier.name;
  response.trabajaOrdenesPago = cashier.paymentOrders;
  response.sucursal = {} as BranchOffice;
  response.sucursal.id = cashier.branchOffice.value;
  response.qrExternoId = cashier.externalQrId;
  return response;
}
